import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CheckboxGroup({ items, checked, onChange }) {
    const visibleItems = items.filter((item) => item.display !== false);
    return (_jsx("div", { className: "checkbox-group", children: visibleItems.map((item) => {
            const isChecked = checked.includes(item.code);
            return (_jsxs("label", { className: `checkbox-group__item ${isChecked ? 'checkbox-group__item--checked' : ''}`, children: [_jsx("input", { type: "checkbox", checked: isChecked, onChange: (e) => onChange(item.code, e.target.checked) }), _jsx("span", { className: "checkbox-group__label", children: item.label })] }, item.code));
        }) }));
}
